// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  var $parcel$bundleURL;function $parcel$resolve(url) {  url = importMap[url] || url;  if (!$parcel$bundleURL) {    try {      throw new Error();    } catch (err) {      var matches = ('' + err.stack).match(        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,      );      if (matches) {        $parcel$bundleURL = matches[0];      } else {        return distDir + url;      }    }  }  return new URL(distDir + url, $parcel$bundleURL).toString();}newRequire.resolve = $parcel$resolve;function $parcel$extendImportMap(map) {  Object.assign(importMap, map);}newRequire.extendImportMap = $parcel$extendImportMap;

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"2Vizs":[function(require,module,exports,__globalThis) {
module.bundle.extendImportMap({
    "eQCjh": "splide.d20f452a.js",
    "2NPNQ": "splide.1209191d.js"
});

},{}],"iMzXp":[function(require,module,exports,__globalThis) {
/* FacetWP Map: let the map fit all markers first, then enable
   filtering so subsequent pan/zoom constrains the results. */ (function() {
    var mapReady = false;
    document.addEventListener('facetwp-maps-loaded', function() {
        if (mapReady || typeof FWP_MAP === 'undefined' || !FWP_MAP.map) return;
        mapReady = true;
        // Wait for the initial fitBounds to settle, then arm filtering
        google.maps.event.addListenerOnce(FWP_MAP.map, 'idle', function() {
            FWP_MAP.is_filtering = true;
        });
    });
})();
/* Header entrance */ var gsap = window.gsap, ScrollTrigger = window.ScrollTrigger;
if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var header = document.querySelector('header');
    if (header) gsap.fromTo(header, {
        opacity: 0
    }, {
        opacity: 1,
        duration: 0.7,
        ease: 'power2.out',
        clearProps: 'opacity'
    });
}
/* Footer image parallax */ var footerBg = document.getElementById('footer-bg');
if (footerBg) gsap.fromTo(footerBg, {
    y: 0
}, {
    y: -120,
    ease: 'none',
    scrollTrigger: {
        trigger: '#footer',
        start: 'top bottom',
        end: 'bottom top',
        scrub: true
    }
});
require("86ab1eb97afa563a").then(function(param) {
    var Splide = param.Splide;
    var initListingCardSliders = /**
		 * Initialize Splide on every listing card gallery slider.
		 * Scoped to `.splide` inside a listing card article so other
		 * sliders on the page are unaffected.
		 */ function initListingCardSliders() {
        var root = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
        var sliders = root.querySelectorAll("article .splide:not(.is-initialized)");
        sliders.forEach(function(el) {
            new Splide(el, {
                type: "fade",
                arrows: true,
                pagination: true,
                perPage: 1,
                perMove: 1,
                gap: 0,
                rewind: true
            }).mount();
        });
    };
    // Initialize sliders already in the DOM.
    initListingCardSliders();
    // Re-initialize after FacetWP or any other AJAX refresh injects new cards.
    document.addEventListener("facetwp-loaded", function() {
        return initListingCardSliders();
    });
    // Fallback: watch for dynamically added listing cards via MutationObserver.
    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            mutation.addedNodes.forEach(function(node) {
                if (node.nodeType !== Node.ELEMENT_NODE) return;
                initListingCardSliders(node);
            });
        });
    });
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
}).catch(function(err) {
    console.error(err);
});
// QR form code submission
if ($('#sfdc-web-to-lead').length) {
    var form = $('#sfdc-web-to-lead');
    form.on('submit', function(e) {
        e.preventDefault(); // stop normal redirect
        form.addClass('loading');
        form.find('input[type="submit"]').prop('disabled', true);
        // Validate required fields before AJAX
        var isValid = true;
        form.find('input[required]').each(function() {
            var input = $(this);
            if ((!input.val() || input.val().trim() === "") && (!input.data('selected') || input.data('selected') === "")) {
                isValid = false;
                input.addClass('field-error');
            } else input.removeClass('field-error');
        });
        if (!isValid) {
            form.removeClass('loading');
            form.find('input[type="submit"]').prop('disabled', false);
            return;
        }
        // Prepare form data for WordPress AJAX
        var formData = form.serialize();
        formData += '&action=submit_to_salesforce';
        formData += '&nonce=' + (window.salesforce_nonce || '');
        formData += '&salesforce_endpoint=' + encodeURIComponent(form.attr('action') || '');
        $.ajax({
            type: 'POST',
            url: window.ajax_url || '/wp-admin/admin-ajax.php',
            data: formData,
            dataType: 'json'
        }).done(function(response) {
            if (response.success) {
                form.html("<h4>Success! Thank you for registering.</h4>");
                $("#instructions").hide();
            } else {
                console.error('Form submission failed:', response.data);
                alert('There was an error submitting the form: ' + (response.data || 'Please try again later.'));
            }
        }).fail(function(xhr, status, error) {
            console.error('AJAX request failed:', error);
            alert('There was an error submitting the form. Please try again later.');
        }).always(function() {
            form.removeClass('loading');
            form.find('input[type="submit"]').prop('disabled', false);
        });
    });
}

},{"86ab1eb97afa563a":"7ssFl"}],"7ssFl":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("5b5d85d701f8c6a1")(module.bundle.resolve("2NPNQ")),
    require("5b5d85d701f8c6a1")(module.bundle.resolve("eQCjh"))
]).then(function() {
    return module.bundle.root('bp4wN');
});

},{"5b5d85d701f8c6a1":"1MWbm"}],"1MWbm":[function(require,module,exports,__globalThis) {
"use strict";
var cacheLoader = require("ca2a84f7fa4a3bb0");
module.exports = cacheLoader(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

},{"ca2a84f7fa4a3bb0":"4yBbG"}],"4yBbG":[function(require,module,exports,__globalThis) {
"use strict";
var cachedBundles = {};
var cachedPreloads = {};
var cachedPrefetches = {};
function getCache(type) {
    switch(type){
        case 'preload':
            return cachedPreloads;
        case 'prefetch':
            return cachedPrefetches;
        default:
            return cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

},{}]},["2Vizs","iMzXp"], "iMzXp", "parcelRequired6e5", {}, "../../../", "/")

//# sourceMappingURL=child.js.map
